const data = {
    videos: [
        {   
            page: "landing",
            url: "https://glamsappspaces.ams3.digitaloceanspaces.com/HomePage1.mov",
            poster: "https://images.pexels.com/photos/1094847/pexels-photo-1094847.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
        },
        {
            page: "landing",
            url: "https://glamsappspaces.ams3.digitaloceanspaces.com/HomePage2.mov",
            poster: "https://images.pexels.com/photos/890500/pexels-photo-890500.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"
        },
        {
            page: "landing",
            url: "https://glamsappspaces.ams3.digitaloceanspaces.com/HomePage3.mov",
            poster: "https://images.pexels.com/photos/3400130/pexels-photo-3400130.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
        },
        {
            page: "landing",
            url: "https://glamsappspaces.ams3.digitaloceanspaces.com/HomePag4.mov",
            poster: "https://images.pexels.com/photos/866876/pexels-photo-866876.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"
        },
        {
            page: "about",
            url: "https://glamsappspaces.ams3.digitaloceanspaces.com/HomePag4.mov",
            poster: "https://images.pexels.com/photos/1261731/pexels-photo-1261731.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
        },
        {
            page: "about",
            url: "https://glamsappspaces.ams3.digitaloceanspaces.com/HomePage1.mov",
            poster: "https://images.pexels.com/photos/2215609/pexels-photo-2215609.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
        }
    ]
}

// https://glamsappspaces.ams3.digitaloceanspaces.com/HomePage4.mp4
// const emailRegex = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z\-\.]{3,10})\.([a-zA-Z]{2,5})$/;

export default data;